<template>
  <div id="app">
    <router-view></router-view>
    <div id="modals">
      <component v-for="(modal, i) in modals" :is="modal.component" v-bind:params="modal.params" :key="'modal'+i"></component>
    </div>
  </div>
</template>

<script>
  import '../assets/main.css'
  import {mapGetters} from 'vuex'

  export default {
    name: 'App',
    computed: {
      ...mapGetters(['modals'])
    }
  }
</script>

<style lang="scss">
  .uk-button-default:hover, .uk-button-default:focus {
    color: inherit;
  }
  @font-face {
    font-family: 'Type001';
    src: url(//uni-admin.chapeu.co.jp/font/Angelan_.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Type002';
    src: url('//uni-admin.chapeu.co.jp/font/Arial Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Type003';
    src: url('//uni-admin.chapeu.co.jp/font/Arial Rounded Bold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Type004';
    src: url(//uni-admin.chapeu.co.jp/font/BALLW___.TTF) format('truetype');
  }

  @font-face {
    font-family: 'Type005';
    src: url(//uni-admin.chapeu.co.jp/font/BAUHS93.TTF) format('truetype');
  }

  @font-face {
    font-family: 'Type006';
    src: url(//uni-admin.chapeu.co.jp/font/CENTURY.TTF) format('truetype');
  }

  @font-face {
    font-family: 'Type007';
    src: url(//uni-admin.chapeu.co.jp/font/COOPBL.TTF) format('truetype');
  }

  @font-face {
    font-family: 'Type008';
    src: url(//uni-admin.chapeu.co.jp/font/Impact.ttf) format('truetype');
  }

  @font-face {
    font-family: 'Type009';
    src: url(//uni-admin.chapeu.co.jp/font/OCRAStd.otf) format('opentype');
  }

  @font-face {
    font-family: 'Type010';
    src: url(//uni-admin.chapeu.co.jp/font/sportsjersey.ttf) format('truetype');
  }
  @font-face {
    font-family: 'Type011';
    src: url(//uni-admin.chapeu.co.jp/font/KozGoStd-Bold.otf) format('opentype');
  }
  @font-face {
    font-family: 'Type012';
    src: url(//uni-admin.chapeu.co.jp/font/KozMinStd-Bold.otf) format('opentype');
  }

  @font-face {
    font-family: 'No001';
    src: url(//uni-admin.chapeu.co.jp/font/001.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No002';
    src: url(//uni-admin.chapeu.co.jp/font/002.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No003';
    src: url(//uni-admin.chapeu.co.jp/font/003.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No004';
    src: url(//uni-admin.chapeu.co.jp/font/004.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No005';
    src: url(//uni-admin.chapeu.co.jp/font/005.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No006';
    src: url(//uni-admin.chapeu.co.jp/font/006.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No007';
    src: url(//uni-admin.chapeu.co.jp/font/007.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No008';
    src: url(//uni-admin.chapeu.co.jp/font/008.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No009';
    src: url(//uni-admin.chapeu.co.jp/font/009.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No010';
    src: url(//uni-admin.chapeu.co.jp/font/010.ttf) format('truetype');
  }

  @font-face {
    font-family: 'No011';
    src: url(//uni-admin.chapeu.co.jp/font/011.ttf) format('truetype');
  }
</style>
